export const actions = {
  async fetchDetailSettingsByCode({commit}, detailCode) {
    return await this.$axios.$get('/DetailSetting/' + detailCode)
  },
  async saveDetailSetting({commit}, {detailSettings}) {
    return await this.$axios.$post('/DetailSetting/', detailSettings)
  },
}
